// extracted by mini-css-extract-plugin
export default {"wrapper":"ClientsImportInProgress--wrapper--245445","title":"ClientsImportInProgress--title--c17ddf"};